module.exports = __webpack_public_path__ + "img/guangGong1.eb637877.png";